export const TEAM_AVAILABILITY_SLICE = 'teamAvailability';
